import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import updateMain from '../services/Main';
import '../style/style.css';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */
/* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: true}}] */

export default function MainImage({ Main }) {
  const [show, setShow] = useState(false);
  let { image } = Main[0];
  let previousImage = image;

  const saveImage = async () => {
    updateMain(Main[0]._id, image);
    image = image.filename;
    previousImage = image;
    setShow(false);
    setShow(true);
  };

  const reset = async () => {
    image = previousImage;
    document.getElementById('main-img-edit').src = `${process.env.REACT_APP_API_URI}/api/image/${image}`;
  };

  return (
    <div className="main-image" id="editar-imagem">
      <img id="main-img-edit" src={`${process.env.REACT_APP_API_URI}/api/image/${Main[0].image}`} alt="novadinamica.com" />
      <div className="buttons">
        <label
          className="custom-file-upload btn-main-image m-0 ms-3"
          style={{
            paddingBottom: '0.5em',
          }}
        >
          <input
            onChange={(e) => {
              document.getElementById('main-img-edit').src = URL
                .createObjectURL(e.target.files[0]);
              image = e.target.files[0];
            }}
            id="file-input"
            type="file"
          />
          Substituir Foto
        </label>
        <Button onClick={saveImage} variant="main-image ms-3">
          Guardar
        </Button>
        <Button onClick={reset} variant="main-image ms-3">
          Cancelar
        </Button>
      </div>
      <SuccessMessage
        show={show}
        setShow={setShow}
        message="A imagem principal foi atualizada com sucesso!"
      />
    </div>
  );
}

MainImage.propTypes = {
  Main: PropTypes.instanceOf(Object).isRequired,
};
